import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
// 引入中文语言包
import zhCn from "element-plus/es/locale/lang/zh-cn";
import axios from "axios";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      teacherList: [],
      oriTeacherList: [],
      selectedTeacherIds: [],
      selectedAll: false,
      // teacherId: date: [startTime, endTime]
      vacationList: {},
      oriVacationList: {},
      // teacherId: date: reason
      vacationReason: {},
      // 控制 删除假期 按钮 显示隐藏 的二维数组
      showDeleteVacation: [],
      // 选择的月份
      selectedMonth: "",
      // 选择的月份 有哪些日，是周几
      monthDates: [],
      // 当天日期
      todayDate: "",
      //
      searchStr: "",
      showSearchResult: false,
      //设置休息时间
      showSetVacation: false,
      //选择日期段
      vacationRange: [],
      // 添加语言配置
      locale: zhCn,
      // 全天 或 自定义时间
      ifTotalDay: "true",
      // 自定义时间的时间段
      timeRange: [],
      startTime: "",
      endTime: "",
      // 固定 或 非固定休息
      ifFixedRest: "true",
      // 添加周几选项
      weekDays: [{
        label: "周一",
        value: "1"
      }, {
        label: "周二",
        value: "2"
      }, {
        label: "周三",
        value: "3"
      }, {
        label: "周四",
        value: "4"
      }, {
        label: "周五",
        value: "5"
      }, {
        label: "周六",
        value: "6"
      }, {
        label: "周日",
        value: "7"
      }],
      selectedWeekDays: [],
      // 选中的周几
      selectedDates: [],
      // 选中的具体日期
      reason: ""
    };
  },
  // 在组件中注册语言包
  setup() {
    return {
      zhCn
    };
  },
  watch: {
    // 监听 日期范围 vacationRange 变化，自动过滤掉 非固定休息选择的日期 超出日期范围的日期
    vacationRange: {
      handler(newRange) {
        if (newRange && newRange.length === 2) {
          const startDate = new Date(newRange[0]);
          const endDate = new Date(newRange[1]);

          // 过滤掉 非固定休息选择的日期 超出日期范围的日期
          this.selectedDates = this.selectedDates.filter(date => {
            const selectedDate = new Date(date);
            return selectedDate >= startDate && selectedDate <= endDate;
          });
        }
      },
      deep: true
    }
  },
  computed: {
    // 动态计算结束时间选项
    endHourOptions() {
      if (!this.startTime) {
        // 如果没有选择开始时间，显示所有选项
        const options = [];
        for (let hour = 0; hour <= 24; hour++) {
          options.push(hour);
        }
        return options;
      }

      // 如果选择了开始时间，只显示大于开始时间的选项
      const startHour = parseInt(this.startTime.split(":")[0]);
      const options = [];
      for (let hour = startHour; hour <= 24; hour++) {
        options.push(hour);
      }
      return options;
    },
    // 动态计算结束时间选项
    startHourOptions() {
      if (!this.endTime) {
        // 如果没有选择结束时间，显示所有选项
        const options = [];
        for (let hour = 0; hour <= 24; hour++) {
          options.push(hour);
        }
        return options;
      }

      // 如果选择了结束时间，只显示小于结束时间的选项
      const endHour = parseInt(this.endTime.split(":")[0]);
      const options = [];
      for (let hour = 0; hour <= endHour; hour++) {
        options.push(hour);
      }
      return options;
    }
  },
  async mounted() {
    console.log("\nEnter page /vacation");

    // 初始化时显示固定行列
    this.$refs.fixedHeader.style.display = "block";
    this.$refs.fixedColumn.style.display = "block";

    //初始获取当前月份
    const now = new Date();
    const currentYear = now.getFullYear();
    const selectedMonth = String(now.getMonth() + 1).padStart(2, "0");
    this.selectedMonth = `${currentYear}-${selectedMonth}`;

    // 获取老师列表
    await this.getTeacherList();
    // 获取选择的月份 有多少天, 是星期几
    await this.getMonthInfo();
    // 获取假期
    await this.queryVacation();

    // console.log("this.selectedMonth: ", this.selectedMonth);
    // console.log("this.monthDates: ", this.monthDates);

    await this.$nextTick();

    //滚动条自动把当天放最左边
    this.todayDate = this.selectedMonth + "-" + now.getDate().toString().padStart(2, "0");
    let today = parseInt(this.todayDate.split("-")[2]);
    const scrollLeft = (today - 1) * 90;
    const scrollContainer = document.getElementById("scrollArea");
    if (scrollContainer) {
      scrollContainer.scrollLeft = scrollLeft;
    }

    // 构造 showDeleteVacation 二维数组，初始值均为 false
    this.showDeleteVacation = [];
    for (let i in this.teacherList) {
      this.showDeleteVacation.push([]);
      for (let j in this.monthDates) {
        this.showDeleteVacation[i].push(false);
      }
    }
  },
  methods: {
    // 获取选择的月份有多少天, 是星期几
    getMonthInfo() {
      const [year, month] = this.selectedMonth.split("-").map(Number);
      const dates = [];

      // 获取当月第一天
      const firstDay = new Date(year, month - 1, 1);
      // 获取当月最后一天
      const lastDay = new Date(year, month, 0);

      // 星期几的中文映射
      const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

      // 生成当月所有日期
      for (let i = 1; i <= lastDay.getDate(); i++) {
        const date = new Date(year, month - 1, i);
        dates.push({
          date: date.getDate(),
          // 日期数字 (1, 2, 3, ...)
          completeDate: this.selectedMonth + "-" + date.getDate().toString().padStart(2, "0"),
          dayOfWeek: date.getDay(),
          // 星期几 (0-6, 0表示周日)
          dayOfWeekText: weekdays[date.getDay()] // 星期几中文 (周一, 周二, ...)
        });
      }
      this.monthDates = dates;

      // 构造 showDeleteVacation 二维数组，初始值均为 false
      this.showDeleteVacation = [];
      for (let i in this.teacherList) {
        this.showDeleteVacation.push([]);
        for (let j in this.monthDates) {
          this.showDeleteVacation[i].push(false);
        }
      }
    },
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr);
          }
          console.log("获取老师列表:", this.teacherList);
          this.oriTeacherList = JSON.parse(JSON.stringify(this.teacherList));
          loading.close();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          loading.close();
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        loading.close();
        alert("catch error");
      }
    },
    //获取选择的月份的假期
    async queryVacation() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let teacherIds = [];
        for (let i in this.teacherList) {
          //只给启用的老师排假期
          if (this.teacherList[i].isActive == 1) {
            teacherIds.push(this.teacherList[i].id);
          }
        }
        let startDate = this.monthDates[0].completeDate;
        let endDate = this.monthDates[this.monthDates.length - 1].completeDate;
        let dateRange = [startDate, endDate];
        console.log("teacherIds:", teacherIds);
        console.log("dateRange:", dateRange);
        let params = {
          teacherIds: teacherIds,
          dateRange: dateRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/vacation/queryVacation", params);
        if (resp1.data.code == "0000") {
          this.vacationList = resp1.data.data;
          this.vacationReason = resp1.data.vacationReason;
          console.log("this.vacationList:", this.vacationList);
          this.oriVacationList = JSON.parse(JSON.stringify(this.vacationList));
          loading.close();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          loading.close();
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        loading.close();
        alert("catch error");
      }
    },
    // 选择月份
    async handleMonthChange(value) {
      let currentMonth = this.todayDate.split("-")[0] + "-" + this.todayDate.split("-")[1];

      //选择的不是当月，滚动条清零，从第一天开始展示
      if (value != currentMonth) {
        const scrollContainer = document.getElementById("scrollArea");
        if (scrollContainer) {
          scrollContainer.scrollLeft = 0;
        }
      }
      //选择的是当月
      else {
        //滚动条自动把当天放最左边
        let today = parseInt(this.todayDate.split("-")[2]);
        const scrollLeft = (today - 1) * 90;
        const scrollContainer = document.getElementById("scrollArea");
        if (scrollContainer) {
          scrollContainer.scrollLeft = scrollLeft;
        }
      }
      console.log("选择的月份:", value);
      this.selectedMonth = value;
      this.getMonthInfo();
      await this.queryVacation();
    },
    //选择老师 多选框
    selectTeacher() {
      console.log("选择的老师:", this.selectedTeacherIds);
    },
    // 点击老师名，也是选择老师
    clickTeacherName(teacherId) {
      // 如果已选择，则取消选择
      if (this.selectedTeacherIds.indexOf(teacherId) != -1) {
        this.selectedTeacherIds = this.selectedTeacherIds.filter(id => id != teacherId);
      }
      // 如果未选择，则选择
      else {
        this.selectedTeacherIds.push(teacherId);
      }
    },
    //全选老师
    selectAllTeacher() {
      //取消全选
      if (!this.selectedAll) {
        this.selectedTeacherIds = [];
      }
      // 全选
      else {
        for (let i = 0; i < this.teacherList.length; i++) {
          this.selectedTeacherIds.push(this.teacherList[i].id);
        }
      }

      // console.log("选择的老师:", this.selectedTeacherIds);
    },
    // 点击全选文字，也是点击全选按钮
    clickSelectAllWord() {
      this.selectedAll = !this.selectedAll;
      this.selectAllTeacher();
    },
    // 展示删除假期按钮
    showDeleteVacationButton(index, index2) {
      // console.log("index2:", index2);
      // console.log("this.showDeleteVacation[index].length:", this.showDeleteVacation[index].length)

      this.showDeleteVacation[index][index2] = true;
    },
    hiddenDeleteVacationButton(index, index2) {
      this.showDeleteVacation[index][index2] = false;
    },
    async deleteVacation(index, index2) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          teacherId: this.teacherList[index].id,
          date: this.monthDates[index2].completeDate
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/vacation/deleteVacation", params);
        if (resp1.data.code == "0000") {
          await this.queryVacation();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //列表横纵滚动
    handleScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      const scrollTop = event.target.scrollTop;

      // 移动固定表头
      this.$refs.fixedHeader.style.transform = `translateX(-${scrollLeft}px)`;

      // 移动固定列
      this.$refs.fixedColumn.style.transform = `translateY(-${scrollTop}px)`;
    },
    //设置假期
    setVacation() {
      if (this.selectedTeacherIds.length == 0) {
        alert("请选择老师");
        return;
      }

      // 清空之前的数据
      this.reason = "";
      this.selectedDates = [];
      this.selectedWeekDays = [];
      this.ifTotalDay = "true";
      this.ifFixedRest = "true";
      this.vacationRange = [];
      this.timeRange = [];
      this.startTime = "";
      this.endTime = "";
      this.showSetVacation = true;
    },
    //双击单元格 设置假期
    doubleClickUnit(index, index2) {
      this.selectedTeacherIds = [this.teacherList[index].id];

      // 默认选择 非固定休息
      this.ifFixedRest = "false";
      this.selectedDates = [this.monthDates[index2].completeDate];
      this.selectedWeekDays = [];

      // 默认选择 全天
      this.ifTotalDay = "true";
      this.timeRange = [];
      this.startTime = "";
      this.endTime = "";

      // 清空原因
      this.reason = "";

      // 如果这个老师 这天 已设置假期
      // 改为选择 自定义时间，获取休假原因
      if (this.vacationList[this.selectedTeacherIds]) {
        if (this.vacationList[this.selectedTeacherIds][this.selectedDates]) {
          if (this.vacationList[this.selectedTeacherIds][this.selectedDates][0] != this.vacationList[this.selectedTeacherIds][this.selectedDates][1]) {
            //选择自定义时间
            this.ifTotalDay = "false";
            this.startTime = this.vacationList[this.selectedTeacherIds][this.selectedDates][0].toString().padStart(2, "0") + ":00";
            this.endTime = this.vacationList[this.selectedTeacherIds][this.selectedDates][1].toString().padStart(2, "0") + ":00";

            // 获取休假原因
            this.reason = this.vacationReason[this.selectedTeacherIds][this.selectedDates];
          }
        }
      }
      this.showSetVacation = true;
    },
    changeIfFixedRest(type) {
      if (type == "fixed") {
        this.ifFixedRest = "true";
      } else if (type == "unfixed") {
        this.ifFixedRest = "false";
      }
      // 防止还有其他情况
      else {
        this.ifFixedRest = "true";
      }
      if (this.ifFixedRest == "true") {
        this.selectedDates = [];
      }
      if (this.ifFixedRest == "false") {
        this.selectedWeekDays = [];
      }
    },
    // 点击周几文字，也是点击周几选择框
    clickWeekdayWord(index) {
      if (this.selectedWeekDays.includes(index)) {
        this.selectedWeekDays = this.selectedWeekDays.filter(item => item !== index);
      } else {
        this.selectedWeekDays.push(index);
      }
      console.log("this.selectedWeekDays:", this.selectedWeekDays);
    },
    // 点击周几选择框
    selectWeekday(index) {
      console.log("\nselectWeekday start");
      if (this.selectedWeekDays.includes(index)) {
        this.selectedWeekDays = this.selectedWeekDays.filter(item => item !== index);
      } else {
        this.selectedWeekDays.push(index);
      }
      console.log("this.selectedWeekDays:", this.selectedWeekDays);
    },
    // 非固定休息，选择日期时，禁用不在日期段范围内的日期
    disabledDate(time) {
      // 如果没有设置 vacationRange，则不禁用任何日期
      if (!this.vacationRange || this.vacationRange.length !== 2) {
        return false;
      }
      const startDate = new Date(this.vacationRange[0]);
      const endDate = new Date(this.vacationRange[1]);

      // 禁用范围外的日期
      return time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime();
    },
    // 保存假期设置
    async saveVacationSetting() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 如果是固定休息
        if (this.ifFixedRest === "true") {
          // 必须检查有没有选日期范围
          if (this.vacationRange.length === 2) {
            if (this.selectedWeekDays.length > 0) {} else {
              alert("请选择固定周几休息");
              return;
            }
          } else {
            alert("请选择日期范围");
            return;
          }

          // 固定休息，默认全天
          this.ifTotalDay = "true";
        }
        // 如果是非固定休息
        else {
          if (this.selectedDates.length > 0) {} else {
            alert("请选择非固定休息的日期");
            return;
          }
        }

        // 如果是自定义时间
        if (this.ifTotalDay === "false") {
          // 必须检查有没有选时间段
          if (this.startTime && this.endTime) {} else {
            alert("请选择自定义的时间段");
            return;
          }
        }
        let selectedDates = [];
        // 如果是固定休息，将选择的周几转换为具体日期
        if (this.ifFixedRest === "true") {
          const startDate = new Date(this.vacationRange[0]);
          const endDate = new Date(this.vacationRange[1]);

          // 遍历日期范围内的每一天
          const currentDate = new Date(startDate);
          while (currentDate <= endDate) {
            // 获取当前日期是星期几 (0-6, 0表示周日)
            const dayOfWeek = currentDate.getDay();

            // 将星期几映射为与selectedWeekDays一致的格式 (1-7, 1表示周一)
            let mappedDayOfWeek = dayOfWeek;
            if (dayOfWeek === 0) {
              mappedDayOfWeek = 7; // 周日映射为7
            } else {
              mappedDayOfWeek = dayOfWeek; // 周一到周六映射为1-6
            }

            // 如果当前日期的星期几在选择的周几中，则添加到selectedDates
            if (this.selectedWeekDays.includes(mappedDayOfWeek.toString())) {
              const dateString = currentDate.toISOString().split("T")[0];
              selectedDates.push(dateString);
            }

            // 移动到下一天
            currentDate.setDate(currentDate.getDate() + 1);
          }
        } else {
          selectedDates = this.selectedDates;
        }
        console.log("选择的日期:", selectedDates);
        let timeRange = [];
        if (this.ifTotalDay == "true") {
          timeRange = ["00:00", "24:00"];
        } else {
          timeRange = [this.startTime, this.endTime];
        }
        console.log("选择的时间段:", timeRange);
        try {
          let params = {
            teacherIds: this.selectedTeacherIds,
            dates: selectedDates,
            timeRange: timeRange,
            reason: this.reason
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/vacation/setVacation", params);
          if (resp1.data.code == "0000") {
            await this.queryVacation();
            this.showSetVacation = false;
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } catch (error) {
          console.log("catch error:", error);
          alert("catch error");
        }
      } finally {
        loading.close();
      }
    },
    cancelVacationSetting() {
      this.showSetVacation = false;
    },
    search() {
      // this.vacationList = {};
      this.teacherList = [];
      this.showSearchResult = true;

      // if (this.searchStr == "") {
      //   return;
      // }

      for (let teacherIndex in this.oriTeacherList) {
        let teacherName = this.oriTeacherList[teacherIndex].name;
        let teacherId = this.oriTeacherList[teacherIndex].id;
        if (teacherName.includes(this.searchStr)) {
          // this.vacationList[teacherId] = this.oriVacationList[teacherId];

          this.teacherList.push(this.oriTeacherList[teacherIndex]);
        }
      }

      // 构造 showDeleteVacation 二维数组，初始值均为 false
      this.showDeleteVacation = [];
      for (let i in this.teacherList) {
        this.showDeleteVacation.push([]);
        for (let j in this.monthDates) {
          this.showDeleteVacation[i].push(false);
        }
      }
    },
    cancelSearch() {
      this.searchStr = "";
      this.vacationList = JSON.parse(JSON.stringify(this.oriVacationList));
      this.teacherList = JSON.parse(JSON.stringify(this.oriTeacherList));
      this.showSearchResult = false;
    }
  }
};